import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import { Card, CardContent, Typography } from '@mui/material';
import CustomCard from '../../../../components/ui/customCard';

export function RetentionCohortChart({ data }) {
  return (
    <CustomCard>
      <CardContent>
        <Typography fontWeight="bold" mb={2}>
          Cohortes clients (retour par mois)
        </Typography>

        <ResponsiveContainer width="100%" height={260}>
          <BarChart data={data}>
            <XAxis dataKey="cohort" />
            <YAxis />
            <Tooltip />
            <Bar dataKey="returning" />
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </CustomCard>
  );
}
